import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=010fa7f0&scoped=true&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"
import style0 from "./TableData.vue?vue&type=style&index=0&id=010fa7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fa7f0",
  null
  
)

export default component.exports